import { MenuItemType } from'./index'

const MENU_ITEMS_PROFILE: MenuItemType[] = [
    {
        key:'myProfile',
        label:'Meu perfil',
        isTitle: true,
    },
    {
        key:'Perfil',
        label:'Perfil',
        icon:'fa-regular fa-circle-user',
        children: [
            {
                key:'viewProfile',
                label:'Meu perfil',
                url:'/profile',
            },
            {
                key:'mySettings',
                label:'Configurações',
                //url:'/profile/configuracoes',
                disable: true,
            }
        ]
    },
    {
        key:'tenants',
        label:'Escritórios',
        icon:'fa-solid fa-users',
        children: [
            {
                key:'viewTenants',
                label:'Meus escritórios',
                //url:'/escritorios',
                disable: true,
            }
        ]
    }
]

export default MENU_ITEMS_PROFILE